import React from 'react';
import PropTypes from 'prop-types';
//import Sticky from 'react-stickynode';
import {PANEL_CONFIG} from 'constants/panelConfig';
import {Tabs, Tab} from 'material-ui/Tabs';

class TabbedPanels extends React.PureComponent {

    constructor(props) {
        super(props);

        this.setSlideIndex = this
            .setSlideIndex
            .bind(this);

        this.handleBackClick = this
            .handleBackClick
            .bind(this);

        this.handleNextClick = this
            .handleNextClick
            .bind(this);

        this.handleSwipe = this
            .handleSwipe
            .bind(this);
    }

    setSlideIndex(value) {
        const {orderId, workOrderActions} = this.props;

        window.scrollTo(0, 0);
        workOrderActions.setSlideIndex(value, orderId);
    }

    handleBackClick(e) {
        const {slideIndex} = this.props;
        e.preventDefault();
        this.setSlideIndex(slideIndex - 1);
    }

    handleNextClick(e) {
        const {slideIndex} = this.props;
        e.preventDefault();
        this.setSlideIndex(slideIndex + 1);
    }

    handleSwipe(index) {
        this.setSlideIndex(index);
    }

    render() {
        const {slideIndex, panels, header, fixedHeaders} = this.props;
        let fixedHeader = null;
        if (fixedHeaders && fixedHeaders[slideIndex]) {
            fixedHeader = fixedHeaders[slideIndex].component;
        }

        const Content = panels.map((panel) => {
            if(panel){
                return (
                    <Tab
                        key={panel.key + '_tab'}
                        label={PANEL_CONFIG[panel.props.detailKey].label}
                        value={PANEL_CONFIG[panel.props.detailKey].slideIndex}
                        buttonStyle={{backgroundColor: '#999',fontSize: '10px', height: '35px'}}
                        >
                        <div className="center-align">
                            {fixedHeader}
                        </div>
                        {panel}

                    </Tab>
                );
            }
        });

        return (
            <div>
                {header}
                <Tabs                                    
                    value={slideIndex} 
                    onChange={this.setSlideIndex}>
                    {Content}
                </Tabs>
            </div>

        );
    }
}

TabbedPanels.propTypes = {
    orderId: PropTypes.string,
    workOrderActions: PropTypes.object,
    slideIndex: PropTypes.number,
    panels: PropTypes.array,
    header: PropTypes.object,
    fixedHeaders: PropTypes.object
};

export default TabbedPanels;


// WEBPACK FOOTER //
// ./src/components/panels/TabbedPanels.js